import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import backIcon from "../../../static/img/back.svg";
import searchIcon from "../../../static/img/searchIconGrey.svg";
import Footer from "../footer/footer.js";
import { getMaximos } from "../../../services/deportistaApi";
import { getUserId } from "../../../services/utilsApi";
import { handleSearch } from "../../../utils/search.js";

const Maximos = () => {
  const [maximos, setMaximos] = useState([]);
  const [filteredMaximos, setFilteredMaximos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMaximos = async () => {
      try {
        const health = await getUserId();
        const uid = health.data.user_id;
        const response = await getMaximos(uid);
        if (response.data.success) {
          setMaximos(response.data.cargas || []);
          setFilteredMaximos(response.data.cargas || []);
        }
      } catch (error) {
        console.error("Error fetching maximos:", error);
      }
    };

    fetchMaximos();
  }, []);

  const onSearchChange = (e) => {
    handleSearch(e, maximos, setSearchTerm, setFilteredMaximos);
  };

  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <div className="maximos-screen">
      <div className="maximos-header">
        <button className="back-button" onClick={handleBack} aria-label="Retroceder">
          <img src={backIcon} alt="Regresar" />
        </button>
        <h2 className="maximos-title">Máximos</h2>
      </div>
      <div className="search-bar">
        <img src={searchIcon} alt="Buscar" className="search-icon" />
        <input
          type="text"
          placeholder="Buscar"
          className="search-input"
          value={searchTerm}
          onChange={onSearchChange}
        />
      </div>

      <div className="maximos-list" data-testid="maximos-list">
        <div className="maximos-subHeader">
          <span className="maximos-header-ejercicio">Tus ejercicios</span>
          <span className="maximos-header-kg">Kg</span>
        </div>
        {filteredMaximos.length > 0 ? (
          filteredMaximos.map((ejercicio, index) => (
            <div className="maximos-item" key={index}>
              <span className="maximos-item-ejercicio">{ejercicio.nombre}</span>
              <span className="maximos-item-kg">{ejercicio.max_peso}</span>
            </div>
          ))
        ) : (
          <div className="maximos-empty">No se encontraron ejercicios</div>
        )}
      </div>

      <Footer activeScreen="actividad" />
    </div>
  );
};

export default Maximos;
